import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Dots from 'react-activity/lib/Dots';
import commonStyles from '../styles/commonStyles';
import { addSoundcastToUser } from '../shared_methods/add_soundcast_to_user';
import PageHeader from './soundcast_landing_page/components/page_header';

class _SettingNewSoundcast extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidUpdate() {
    const location = (this.props.history && this.props.history.location) || {};
    const userInfo = (location.state || {}).userInfo || this.props.userInfo;
    const hasUser = userInfo && userInfo.firstName;
    const hasEmail = userInfo && userInfo.email && userInfo.email[0];
    if (
      !this.addSoundcastToUserCalled &&
      hasUser &&
      hasEmail &&
      location.state &&
      location.state.soundcast
    ) {
      this.addSoundcastToUserCalled = true; // lock
      console.log(`SettingNewSoundcast executing addSoundcastToUser`);
      const { soundcastID, soundcast, sumTotal } = location.state;
      const checked = location.state.checked || 0;
      let totalPrice = 0;
      if (soundcast.prices && soundcast.prices[checked] && soundcast.prices[checked].price) {
        totalPrice = Number(soundcast.prices[checked].price);
      }
      addSoundcastToUser(
        null, // empty charge
        userInfo,
        soundcastID,
        soundcast,
        checked,
        sumTotal,
        null, // empty coupon
        totalPrice,
        this.props.history
      );
    }
  }

  render() {
    return (
      <div>
        <PageHeader />
        <section
          className="padding-110px-tb xs-padding-60px-tb bg-white builder-bg border-none"
          id="title-section1"
        >
          <div className="container">
            <div className="row">
              <div style={commonStyles.dots}>
                <Dots style={{ display: 'flex' }} color="#727981" size={32} speed={1} />
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { userInfo } = state.user;
  return { userInfo };
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

const SettingNewSoundcast_worouter = connect(
  mapStateToProps,
  mapDispatchToProps
)(_SettingNewSoundcast);

export const SettingNewSoundcast = withRouter(SettingNewSoundcast_worouter);
